import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { thousands } from 'react-wot-bootstrap/lib/helpers/format_number'

import styles from './FamePoints.scss'

const FamePoints = ({ value, notAvailable, inactive, iconPosition, size, mixClassName }) => {
    const className = classNames(
        styles.base,
        styles[`base__${size}`],
        styles[`base__${iconPosition}`],
        notAvailable && styles['base__not-available'],
        inactive && styles.base__inactive,
        mixClassName,
    )
    return (
        <span className={className}>
            {thousands(value)}
        </span>
    )
}

FamePoints.propTypes = {
    value: PropTypes.number.isRequired,
    notAvailable: PropTypes.bool,
    inactive: PropTypes.bool,
    iconPosition: PropTypes.oneOf(['before', 'after']).isRequired,
    size: PropTypes.oneOf(['small', 'medium', 'regular', 'large']).isRequired,
    mixClassName: PropTypes.string,
}

FamePoints.defaultProps = {
    notAvailable: false,
    inactive: false,
    iconPosition: 'after',
    size: 'regular',
}

export default FamePoints



// WEBPACK FOOTER //
// ./components/FamePoints/FamePoints.jsx